import { useEffect, useState, useCallback } from 'react';
import { ExecutiveSVG, CompanySVG } from './styled';
import { useTheme } from '@simplywallst/ui-core';
import { VisxText } from '@/components/VisxText';

interface Props {
  x: number;
  y: number;
  companies: number;
  individuals: number;
  type: 'bought' | 'sold';
}

const executiveSVGWidth = 12;
const companySVGWidth = 10;
const padding = 14;
const marginRight = 8;

const InsiderCount = ({ x, y, companies, individuals, type }: Props) => {
  const theme = useTheme();
  const [width, setWidth] = useState(0);
  const [executiveCountWidth, setExecutiveCountWidth] = useState(0);
  const [companyCountWidth, setCompanyCountWidth] = useState(0);

  const executiveCountRef = useCallback((node: SVGSVGElement) => {
    if (node) {
      setExecutiveCountWidth(node.getBBox().width);
    }
  }, []);

  const companyCountRef = useCallback((node: SVGSVGElement) => {
    if (node) {
      setCompanyCountWidth(node.getBBox().width);
    }
  }, []);

  useEffect(() => {
    setWidth(
      executiveSVGWidth +
        padding +
        executiveCountWidth +
        marginRight +
        companySVGWidth +
        padding +
        companyCountWidth
    );
  }, [executiveCountWidth, companyCountWidth]);

  return (
    <svg
      x={x - (type === 'sold' ? width : 0)}
      y={y}
      shapeRendering="geometricPrecision"
    >
      <svg width={executiveSVGWidth + padding + executiveCountWidth}>
        <ExecutiveSVG type={type} />
        <VisxText
          innerRef={executiveCountRef}
          x={executiveSVGWidth + padding}
          y="13"
          verticalAnchor="middle"
          fill={
            individuals <= 0 ? theme.color.whiteRGBA(0.3) : theme.color.white
          }
          typography="tiny"
        >
          {individuals.toString()}
        </VisxText>
      </svg>
      <svg
        width={companySVGWidth + padding + companyCountWidth}
        x={executiveSVGWidth + padding + executiveCountWidth + marginRight}
      >
        <CompanySVG type={type} />
        <VisxText
          innerRef={companyCountRef}
          x={companySVGWidth + padding}
          y="13"
          verticalAnchor="middle"
          fill={companies <= 0 ? theme.color.whiteRGBA(0.3) : theme.color.white}
          typography="tiny"
        >
          {companies.toString()}
        </VisxText>
      </svg>
    </svg>
  );
};

export default InsiderCount;
